import { render, staticRenderFns } from "./faceResult.vue?vue&type=template&id=ef8d1718&scoped=true"
import script from "./faceResult.vue?vue&type=script&lang=ts"
export * from "./faceResult.vue?vue&type=script&lang=ts"
import style0 from "./faceResult.vue?vue&type=style&index=0&id=ef8d1718&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8d1718",
  null
  
)

export default component.exports